import * as React from "react";
import { Multi_SkillTag } from "src/domain/model/skill_tag";
import GoldLink from "src/presentation/common/atom/btn/gold_link";
import styled from "styled-components";
import {
  customerConfig,
  jobCareerConfig,
  pastCaseProjectConfig,
  skillTagConfig,
} from "../../../../../config/language/ja-JP/domain/model_text";
import { ConstBreakPoint } from "../../../../../config/styles_const/styles_const";
import { Customer } from "../../../../../domain/model/customer";
import { JobCareer } from "../../../../../domain/model/job_career";
import {
  PastCaseProject,
  intervalString,
} from "../../../../../domain/model/past_case_project";
import Assets from "../../../../assets/img/assets";
import HeadlineMiddle from "../../../../common/atom/text/headline_middle";
import ProfileRightBtnWrapper from "../../../../common/atom/wrapper/profile_right_btn_wrapper";
import CustomerProfile from "./customer_profile";

interface IProps {
  customer: Customer | null;
  jobCareers: JobCareer[];
  pastCaseProjects: PastCaseProject[];
}

export const CustomerMypageMainCustomer: React.FC<IProps> = (props) => {
  const { customer, jobCareers, pastCaseProjects } = props;
  const [tab, setTab] = React.useState<number>(0);

  if (!customer) {
    return <div />;
  }

  let res: JSX.Element;

  const tagsByCategory = (category: Multi_SkillTag.Category) => {
    return (
      <>
        <TagCategory>
          {skillTagConfig.multiSkillTagCategoryList.get(category)}
        </TagCategory>
        <TagList>
          {customer.multiSkillTags
            .filter((tag) => tag.category === category)
            .slice(0, 2)
            .map((v) => {
              return <Tag key={v.id}>{v.name}</Tag>;
            })}
        </TagList>
      </>
    );
  };

  // 通常ページ

  res = (
    <React.Fragment>
      <CustomerProfile customer={customer} />

      <TabContainer>
        <Tab
          active={tab === 0}
          onClick={() => {
            setTab(0);
          }}
        >
          職歴情報を見る
        </Tab>
        <div style={{ width: 1, height: 40, backgroundColor: "#EBF0F1" }} />
        <Tab
          active={tab === 1}
          onClick={() => {
            setTab(1);
          }}
        >
          希望条件を確認する
        </Tab>
      </TabContainer>

      {tab === 0 && (
        <JobCareerSection jobCareers={jobCareers} customer={customer} />
      )}
      {tab === 1 && (
        <PastProjectSection
          pastCaseProjects={pastCaseProjects}
          customer={customer}
        />
      )}

      <TagSection>
        <TagSectionTitle>スキル・経験</TagSectionTitle>
        <TagSectionInner>
          <TagSectionInnerLeft>
            {tagsByCategory(
              Multi_SkillTag.Category.Category_IntroductionOperation
            )}
            {tagsByCategory(
              Multi_SkillTag.Category.Category_PersonalConnections
            )}
            {tagsByCategory(Multi_SkillTag.Category.Category_DevelopFramework)}
          </TagSectionInnerLeft>
          <TagSectionInnerRight>
            {tagsByCategory(Multi_SkillTag.Category.Category_OverseasExpansion)}
            {tagsByCategory(Multi_SkillTag.Category.Category_Programming)}
            {tagsByCategory(Multi_SkillTag.Category.Category_AI)}
          </TagSectionInnerRight>
        </TagSectionInner>
      </TagSection>
    </React.Fragment>
  );

  return res;
};

export default CustomerMypageMainCustomer;

interface IJobCareerProps {
  customer: Customer;
  jobCareers: JobCareer[];
}

const JobCareerSection: React.FC<IJobCareerProps> = (props) => {
  const { customer, jobCareers } = props;

  const sortedJobCareers = jobCareers.slice().sort((a, b) => {
    const aStartedNumber =
      Number(a.startedAt.year) * 100 + Number(a.startedAt.month || 0);
    const bStartedNumber =
      Number(b.startedAt.year) * 100 + Number(b.startedAt.month || 0);
    return bStartedNumber - aStartedNumber;
  });

  let lastId = "";
  if (sortedJobCareers.length > 0) {
    lastId = sortedJobCareers[sortedJobCareers.length - 1].id;
  }

  return (
    <TabSectionContainer>
      <EditButtonContainer>
        <ProfileRightBtnWrapper>
          <ButtonWrapper>
            <EditLink to={"/customer/mypage/customer/_edit_job_career"}>
              編集する
            </EditLink>
          </ButtonWrapper>
          <ButtonWrapper>
            <EditLink to={"/customer/mypage/customer/_pdf"}>
              PDFとして出力する
            </EditLink>
          </ButtonWrapper>
        </ProfileRightBtnWrapper>
      </EditButtonContainer>
      <HeadlineMiddle>職務要約</HeadlineMiddle>
      <div
        style={{
          marginTop: 30,
          marginBottom: 50,
          fontSize: 15,
          fontWeight: "normal",
          color: "#333333",
          whiteSpace: "pre-wrap",
        }}
      >
        {customer.dutySummary}
      </div>
      {sortedJobCareers.map((jobCareer: JobCareer) => {
        return (
          <div key={jobCareer.id}>
            <ItemInner>
              <JobCareerRange>{`${jobCareer.getStartedAtString()}~${jobCareer.getEndedAtString()}`}</JobCareerRange>
              <div style={{ display: "flex" }}>
                <Img src={Assets.building} />
                <ItemTitle>{jobCareer.companyName}</ItemTitle>
              </div>
              <JobCareerPost>
                {jobCareer.post} |{" "}
                {jobCareerConfig.employmentStatusList.get(
                  jobCareer.employmentStatus
                )}
              </JobCareerPost>
              <JobCareerDescription>
                {jobCareer.description}
              </JobCareerDescription>
            </ItemInner>
            {lastId !== jobCareer.id && (
              <div
                style={{
                  width: 1,
                  height: 45,
                  margin: "10px 20px",
                  backgroundColor: "#9A8C64",
                }}
              />
            )}
          </div>
        );
      })}
    </TabSectionContainer>
  );
};

interface IPastProjectProps {
  customer: Customer;
  pastCaseProjects: PastCaseProject[];
}

const PastProjectSection: React.FC<IPastProjectProps> = (props) => {
  const { customer, pastCaseProjects } = props;

  let lastId = "";
  if (pastCaseProjects.length > 0) {
    lastId = pastCaseProjects[pastCaseProjects.length - 1].id;
  }

  return (
    <TabSectionContainer>
      <EditButtonContainer>
        <ProfileRightBtnWrapper>
          <ButtonWrapper>
            <EditLink to={"/customer/mypage/customer/_edit_past_project"}>
              編集する
            </EditLink>
          </ButtonWrapper>
        </ProfileRightBtnWrapper>
      </EditButtonContainer>
      <HeadlineMiddle>希望条件</HeadlineMiddle>
      <PastProjectInfoContainer>
        <div style={{ flex: "1" }}>
          <InfoArea>
            <div style={{ display: "flex", marginBottom: 16 }}>
              <InfoLabel>稼働頻度</InfoLabel>
              <InfoValue>
                {customerConfig.workingFrequencyList[customer.workingFrequency]}
              </InfoValue>
            </div>
            <div style={{ display: "flex", marginBottom: 16 }}>
              <InfoLabel>報酬目安</InfoLabel>
              <InfoValue>
                {customerConfig.requestedFeeList[customer.requestedFee]}
              </InfoValue>
            </div>
            <div style={{ display: "flex", marginBottom: 16 }}>
              <InfoLabel>その他条件</InfoLabel>
              <InfoValue>{customer.requestedCondition}</InfoValue>
            </div>
          </InfoArea>
        </div>
        <div style={{ flex: "1" }}>
          <InfoArea>
            <div style={{ display: "flex", marginBottom: 16 }}>
              <InfoLabel>稼働スタンス</InfoLabel>
              <InfoValue>
                {customerConfig.workIntentionList.get(customer.workIntention)}
              </InfoValue>
            </div>
            <div style={{ display: "flex", marginBottom: 16 }}>
              <InfoLabel>正社員の可能性</InfoLabel>
              <InfoValue>
                {customerConfig.fullTimePossibilityList.get(
                  customer.fullTimePossibility
                )}
              </InfoValue>
            </div>
            <div style={{ display: "flex", marginBottom: 16 }}>
              <InfoLabel>仲介案件</InfoLabel>
              <InfoValue>
                {customerConfig.brokerageProjectPossibilityList.get(
                  customer.brokerageProjectPossibility
                )}
              </InfoValue>
            </div>
          </InfoArea>
        </div>
      </PastProjectInfoContainer>
      <div style={{ marginBottom: 20, marginTop: 40 }}>
        <HeadlineMiddle>過去の契約例</HeadlineMiddle>
      </div>
      {pastCaseProjects.map((project: PastCaseProject) => {
        return (
          <div key={project.id}>
            <ItemInner>
              <PastProjectContent>
                <div style={{ flex: 1 }}>
                  <div style={{ display: "flex" }}>
                    <Img src={Assets.past_project} />
                    <ItemTitle>
                      {project.title} - {project.feePerMonth}万円/月
                    </ItemTitle>
                  </div>
                  <PastProjectDescription>{`約${
                    project.meetingNum
                  }回/${intervalString(
                    project.meetingInterval
                  )}の頻度で、1回あたり約${
                    project.meetingMinutes
                  }分の打ち合わせ\n約${
                    project.workingHour
                  }時間/${intervalString(
                    project.workingInterval
                  )}の実稼働`}</PastProjectDescription>
                </div>
                <div style={{ flex: 1 }}>
                  <InfoArea>
                    <div style={{ display: "flex", marginBottom: 16 }}>
                      <PastProjectInfoLabel>稼働方法</PastProjectInfoLabel>
                      <InfoValue>
                        {pastCaseProjectConfig.workLocationList.get(
                          project.workLocation
                        )}
                      </InfoValue>
                    </div>
                    <div style={{ display: "flex", marginBottom: 16 }}>
                      <PastProjectInfoLabel>
                        コミュニケーション
                      </PastProjectInfoLabel>
                      <InfoValue>
                        {pastCaseProjectConfig.workCommunicationList.get(
                          project.workCommunication
                        )}
                      </InfoValue>
                    </div>
                    <div style={{ display: "flex", marginBottom: 16 }}>
                      <PastProjectInfoLabel>稼働内容</PastProjectInfoLabel>
                      <InfoValue>
                        {pastCaseProjectConfig.workDetailList.get(
                          project.workDetail
                        )}
                      </InfoValue>
                    </div>
                  </InfoArea>
                </div>
              </PastProjectContent>
              <PastProjectReward>
                成果報酬
                <br />
                {project.achievementReward}
              </PastProjectReward>
            </ItemInner>
            {lastId !== project.id && (
              <div
                style={{
                  width: 1,
                  height: 45,
                  margin: "10px 20px",
                  backgroundColor: "#9A8C64",
                }}
              />
            )}
          </div>
        );
      })}
    </TabSectionContainer>
  );
};

const TagSection = styled.div`
  margin-top: 42px;
  border-top: solid 1px #ebf0f1;
  padding: 32px 0px;
`;

const TagSectionTitle = styled.div`
  font-size: 15px;
  color: #333333;
  font-weight: bold;
  margin-bottom: 7px;
`;

const TagSectionInner = styled.div`
  display: flex;
`;

const TagSectionInnerLeft = styled.div`
  flex: 1;
`;

const TagSectionInnerRight = styled.div`
  flex: 1;
`;

const TagCategory = styled.div`
  font-size: 12px;
  color: #333333;
  font-weight: normal;
  margin-bottom: 7px;
`;

const TagList = styled.div`
  margin-bottom: 17px;
  display: flex;
`;

const Tag = styled.div`
  color: #a4a4a4;
  font-size: 10px;
  font-weight: bold;
  border: solid 1px #d8d8d8;
  border-radius: 20px;
  padding: 3px 28px;
  margin-right: 6px;
`;

const ButtonWrapper = styled.div`
  margin-left: 10px;
`;

const TabContainer = styled.div`
  display: flex;
  border: solid 1px #ebf0f1;
  border-radius: 10px;
  overflow: hidden;
  height: 40px;
`;

const Tab = styled.div<{ active: boolean }>`
  flex: 1;
  height: 40px;
  text-align: center;
  line-height: 40px;
  background-color: ${(props) => (props.active ? "#9A8C64" : "white")};
  color: ${(props) => (props.active ? "white" : "#A4A4A4")};
  cursor: pointer;
`;
Tab.defaultProps = {
  active: false,
};

const TabSectionContainer = styled.div`
  margin-top: 30px;
  padding: 40px 20px;
  padding-bottom: 40px;
  border: solid 1px #ebf0f1;
  border-radius: 10px;
  @media screen and (min-width: ${ConstBreakPoint.Default}) {
    padding: 0px 50px;
    padding-bottom: 50px;
  }
`;

const Img = styled.img`
  width: 32px;
  height: 32px;
`;

const ItemTitle = styled.div`
  margin-left: 10px;
  font-size: 20px;
  line-height: 32px;
  color: #333333;
  font-weight: bold;
`;

const ItemInner = styled.div`
  padding: 12px 0px;
`;

const JobCareerPost = styled.div`
  font-size: 16px;
  font-weight: normal;
  color: #a4a4a4;
  margin: 12px 0px;
`;

const JobCareerDescription = styled.div`
  font-size: 15px;
  font-weight: normal;
  color: #333333;
  margin: 12px 0px;
  line-height: 18px;
  white-space: pre-wrap;
`;

const JobCareerRange = styled.div`
  font-size: 15px;
  font-weight: normal;
  color: #333333;
  margin: 12px 0px;
`;

const InfoArea = styled.div`
  border-left: solid 5px #9a8c64;
  padding-left: 25px;
  margin-top: 20px;
  margin-bottom: 10px;
`;

const InfoLabel = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  font-size: 12px;
  font-weight: bold;
  width: 90px;
  color: #333333;
`;

const PastProjectInfoLabel = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  font-size: 12px;
  font-weight: bold;
  width: 120px;
  color: #333333;
`;

const InfoValue = styled.div`
  font-size: 12px;
  font-weight: bold;
  padding-right: 10px;
  color: #333333;
`;

const PastProjectDescription = styled.div`
  font-size: 15px;
  font-weight: bold;
  color: #333333;
  margin: 20px 0px;
  white-space: pre-wrap;
  line-height: 24px;
`;

const PastProjectReward = styled.div`
  font-size: 15px;
  font-weight: normal;
  color: #333333;
  margin: 10px 0px;
  white-space: pre-wrap;
`;

const PastProjectInfoContainer = styled.div`
  display: block;
  margin-bottom: 60;
  @media screen and (min-width: ${ConstBreakPoint.Default}) {
    display: flex;
  }
`;

const PastProjectContent = styled.div`
  display: block;
  @media screen and (min-width: ${ConstBreakPoint.Default}) {
    display: flex;
  }
`;

const EditButtonContainer = styled.div`
  display: none;
  @media screen and (min-width: ${ConstBreakPoint.Default}) {
    display: block;
  }
`;

const EditLink = styled(GoldLink)`
  font-size: 12px;
`;



// WEBPACK FOOTER //
// ./src/presentation/component/customer/mypage/info/customer_mypage_main_customer.tsx